module.exports = __webpack_public_path__ + "img/kr-product-content4-img-1.37661c8.png";